import { defineMessages } from 'react-intl';

const messages = defineMessages({
  querystring: {
    id: 'Query',
    defaultMessage: 'Query',
  },
  headerConfiguration: {
    id: 'Header',
    defaultMessage: 'Header',
  },
  header: {
    id: 'Header text',
    defaultMessage: 'Header text',
  },
  headerUrl: {
    id: 'Header url',
    defaultMessage: 'Header url or object',
  },
  headerTag: {
    id: 'Header Tag',
    defaultMessage: 'Header Tag',
  },
  columnsConfiguration: {
    id: 'Columns configuration',
    defaultMessage: 'Columns',
  },
  columnsCount: {
    id: 'Number of columns',
    defaultMessage: 'Number of columns',
  },
  slidesToScroll: {
    id: 'Slides to scroll',
    defaultMessage: 'Slides to scroll',
  },
  autoPlay: {
    id: 'Auto Play',
    defaultMessage: 'Auto Play',
  },
  speedAutoplay: {
    id: 'Speed Autoplay',
    defaultMessage: 'Speed Autoplay',
  },
  imageConfiguration: {
    id: 'Image position/size',
    defaultMessage: 'Image position/size',
  },
  imageWidth: {
    id: 'Image width',
    defaultMessage: 'Image width',
  },
  imageWidthDescription: {
    id: 'Left/Right image width (default 2/12)',
    defaultMessage: 'Left/Right image width (default 4/12)',
  },
  alignment: {
    id: 'Alignment',
    defaultMessage: 'Alignment',
  },
  imagePosition: {
    id: 'Image position',
    defaultMessage: 'Image position',
  },
  noImage: {
    id: 'No image',
    defaultMessage: 'No image',
  },
  background: {
    id: 'background',
    defaultMessage: 'background',
  },
  up: {
    id: 'up',
    defaultMessage: 'up',
  },
  left: {
    id: 'left',
    defaultMessage: 'left',
  },
  right: {
    id: 'right',
    defaultMessage: 'right',
  },
  down: {
    id: 'down',
    defaultMessage: 'down',
  },
  showTitle: {
    id: 'Show Title',
    defaultMessage: 'Show Title',
  },
  imagePositionDescription: {
    id: 'Default with no image',
    defaultMessage: 'Default with no image',
  },
  titleConfiguration: {
    id: 'Title configuration',
    defaultMessage: 'Title',
  },
  titleTag: {
    id: 'titleTag',
    defaultMessage: 'Title Level',
  },
  titleTagDescription: {
    id: 'Default HTML tag will be H3',
    defaultMessage: 'Default HTML tag will be H3',
  },
  descriptionTitle: {
    id: 'descriptionTitle',
    defaultMessage: 'Show Description',
  },
  descriptionDescription: {
    id: 'descriptionDescription',
    defaultMessage: 'If selected, the description will be shown',
  },
  dateDescription: {
    id: 'Show effectiveDate',
    defaultMessage: 'Show effectiveDate',
  },
  moreLinkConfiguration: {
    id: 'moreLinkConfiguration',
    defaultMessage: 'More link',
  },
  moreLinkText: {
    id: 'moreLinkText',
    defaultMessage: 'Text',
  },
  moreLinkTextDescription: {
    id: 'moreLinkTextDescription',
    defaultMessage: 'More link text',
  },
  moreLinkUrl: {
    id: 'moreLinkUrl',
    defaultMessage: 'More link url or object',
  },
  moreLinkUrlDescription: {
    id: 'moreLinkUrlDescription',
    defaultMessage: 'Paste an external link or a Plone object',
  },
  carouselSliderOptions: {
    id: 'carouselSliderOptions',
    defaultMessage: 'Carousel/Slider Options',
  },
  itemDisplayOptions: {
    id: 'itemDisplayOptions',
    defaultMessage: 'Item Display Options',
  },
  eventDate: {
    id: 'eventDate',
    defaultMessage: 'Show Event Date',
  },
  eventTime: {
    id: 'eventTime',
    defaultMessage: 'Show Event Time',
  },
  eventLocation: {
    id: 'eventLocation',
    defaultMessage: 'Show Event Location',
  },
  showEventCard: {
    id: 'Show Event Card',
    defaultMessage: 'Show Event Card',
  },
  showAsQuote: {
    id: 'Show as Quote',
    defaultMessage: 'Show as Quote',
  },
  date: {
    id: 'date',
    defaultMessage: 'Show Effective Date',
  },
  expires: {
    id: 'expires',
    defaultMessage: 'Show Expiration Date',
  },
  showRecurrence: {
    id: 'recurrance',
    defaultMessage: 'Show Recurrence',
  },
  showRecurrenceDescription: {
    id: 'recurranceDescription',
    defaultMessage:
      'If enable the next recurrence of the events will show up the date. In addtion, the query order will be overwritten to show items sorted by start dates. Note: listing with small batch size my present recurrence out of order due to results',
  },
  thisContentHasNoImage: {
    id: 'This content has no image, this is a default placeholder.',
    defaultMessage: 'This content has no image, this is a default placeholder.',
  },
  pause: {
    id: 'Pause',
    defaultMessage: 'Pause',
  },
  play: {
    id: 'Play',
    defaultMessage: 'Play',
  },
  fetchPriority: {
    id: 'fetchPriority',
    defaultMessage: 'Fetch Priority',
  },
  creatorauthor: {
    id: 'creatorauthor',
    defaultMessage: 'Creator/Author',
  },
  showTags: {
    id: 'showTags',
    defaultMessage: 'Show Tags',
  },
});

export default messages;
